import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const Card = ({ imageSrc, title, description }) => {

  return (
    <div className="bg-white shadow-md rounded-lg pb-4 overflow-hidden">
      <img src={imageSrc} alt={title} className="w-full h-40 object-cover" />

      <div className="px-7 py-7 pb-5 lg:pb-20 text-left">
        <h3 className="font-semibold text-xl">{title}</h3>
        <div className="text-[#231F20] mt-2">{parse(description)}</div>
      </div>
    </div>
  );
};

Card.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Card;
